import { createAsyncThunk } from '@reduxjs/toolkit';

import { quote } from 'src/api';

export const createQuote = createAsyncThunk('payment/createQuote', async (data: any, thunkAPI) => {
  try {
    const response = await quote.createQuote(data);

    if (response.status === 401) {
      return thunkAPI.rejectWithValue('401 Unauthorized');
    }

    if (!response.ok) {
      const json = await response.json();

      return thunkAPI.rejectWithValue(json);
    }

    return await response.json();
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error);
  }
});


